module.exports = __webpack_public_path__ + "4e0efdbbd6d33c202ad25df188188f4f.pdf";